import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";
import { Blog } from "../../models/blog";
import NewsEntry from "./NewsEntry";

export default function NewsArchive({
  year,
  items,
}: {
  year: string;
  items: Blog[];
}) {
  return (
    <Disclosure>
      {({ open }) => (
        <div className="border rounded-xl overflow-hidden">
          <Disclosure.Button className="flex justify-between items-center w-full px-6 py-4 text-left text-xl font-bold bg-gray-100 hover:bg-gray-200">
            <span>Highlights {year}</span>
            <ChevronDownIcon
              className={`w-6 h-6 transform transition-transform ${open ? "rotate-180" : ""
                }`}
            />
          </Disclosure.Button>
          <Disclosure.Panel className="px-4 lg:px-8 py-8">
            <div className="flex flex-col md:gap-16 gap-12">
              {items.map((item, index) => (
                <NewsEntry news={item} index={index} key={index} />
              ))}
            </div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
}
